import { connect } from "react-redux";
import { __Currency, __Lang, __UrlParams } from "../../../../_core/core";
import { KENO_GAME_TYPE } from "../../../config/Game";
import { useEffect, useState } from "react";
import moment from "moment";

let firstDisplay = false;
const PopupWin = (_props: any) => {
  const [lastTickets, setLastTickets] = useState<any[]>([]);
  const [displayPopup, setDisplayPopup] = useState<boolean>(false);

  const getLastTickets = () => {
    if (_props.history.length === 0) return [];

    let maxDate = moment(_props.history[0].dateTime).unix();

    let filteredTickets = _props.history.filter((ticket: any) => {
      return (
        moment(ticket.drawTime).unix() > maxDate &&
        ticket.kenoGameType === KENO_GAME_TYPE
      );
    });

    setLastTickets(filteredTickets);
  };

  const closePopup = () => setDisplayPopup(false);

  useEffect(() => {
    if (
      __UrlParams.props.noWrapper &&
      __UrlParams.props.noWrapper === "false"
    ) {
      getLastTickets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.history]);

  useEffect(() => {
    if (lastTickets.length > 0 && !firstDisplay) {
      setDisplayPopup(true);
      firstDisplay = true;
    }
  }, [lastTickets]);

  useEffect(() => {
    if (!_props.bettingOpen) {
      setDisplayPopup(false);
    }
  }, [_props.bettingOpen]);

  if (!displayPopup) return null;

  return (
    <div className="screen-blocker">
      <div className="popup-bet-box">
        <button className="close-btn" onClick={() => closePopup()}>
          x
        </button>
        <h4 className="popup-header">
          {__Lang.translate("n:TEXT_COLUMBIA_POPUP")}
        </h4>
        <div className="popup-last-results-wrapper">
          <table className="popup-last-results-table">
            <tbody>
              {lastTickets.map((ticket) => (
                <tr key={`LastTicket${ticket.ticketNumber}`}>
                  <td>
                    {__Lang.translate("n:play.ticketNumber")}:{" "}
                    {ticket.ticketNumber}
                  </td>
                  <td width="40%">
                    <div className="ball-tickets-wrapper">
                      {ticket.drawResults.map((ball: any) => (
                        <span
                          className="last-results-ball"
                          key={`LastResults${ticket.ticketNumber}-${ball}`}
                        >
                          {ball}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td>
                    {" "}
                    {__Lang.replace("n:play.winMessage", {
                      win: __Currency.format(ticket.totalPrize),
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    history: state.game.GAMEPLAY.history,
    drawNumber: state.game.GAMEPLAY.drawNumber,
    bettingOpen: state.game.GAMEPLAY.bettingOpen,
  };
};

export default connect(mapStateToProps, {})(PopupWin);
